import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import Checkbox from 'ext-ui/components/Checkbox/Checkbox'
import React from 'react'
import { useTranslate } from 'src/localization/Trns'
import { TransactionExpenseCategoryStatus } from 'src/models/transaction.models'
import { css } from 'styled-components'

interface ExpenseCategoryStatusFilterProps {
  expenseCategoryStatusesSet: Set<string>
  handleExpenseCategoryStatusesSelection: (status: string) => Set<string>
}

const ExpenseCategoryStatusFilter: React.FC<
  ExpenseCategoryStatusFilterProps
> = ({
  expenseCategoryStatusesSet,
  handleExpenseCategoryStatusesSelection,
}) => {
  const translate = useTranslate()
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        gap: 12px;
      `}
    >
      <div
        css={css`
          ${getFontCss(
            14,
            themeConstants.colors.font_primary,
            styleConstants.fontFamilies.medium,
          )};
        `}
      >
        {translate('Expense Category Status')}
      </div>
      <div className="flex-row align-center gap-2">
        <Checkbox
          id="expense-category-attached"
          onChange={(): void => {
            handleExpenseCategoryStatusesSelection(
              TransactionExpenseCategoryStatus.Attached,
            )
          }}
          checked={expenseCategoryStatusesSet.has(
            TransactionExpenseCategoryStatus.Attached,
          )}
          aria-label={translate('Attached')}
        />
        <label
          htmlFor="expense-category-attached"
          css={css`
            ${getFontCss(
              14,
              themeConstants.colors.font_primary,
              styleConstants.fontFamilies.regular,
            )};
            cursor: pointer;
          `}
        >
          {translate('Attached')}
        </label>
      </div>
      <div className="flex-row align-center gap-2">
        <Checkbox
          id="expense-category-missing"
          onChange={(): void => {
            handleExpenseCategoryStatusesSelection(
              TransactionExpenseCategoryStatus.Missing,
            )
          }}
          checked={expenseCategoryStatusesSet.has(
            TransactionExpenseCategoryStatus.Missing,
          )}
          aria-label={translate('Missing')}
        />
        <label
          htmlFor="expense-category-missing"
          css={css`
            ${getFontCss(
              14,
              themeConstants.colors.font_primary,
              styleConstants.fontFamilies.regular,
            )};
            cursor: pointer;
          `}
        >
          {translate('Missing')}
        </label>
      </div>
    </div>
  )
}

export default ExpenseCategoryStatusFilter
